import {InfoWindow, InfoWindowProps} from "../InfoWindow/InfoWindow";
import {LocatableEntity} from "@ots-frontend/ots-data";
import {InfoWindowBody} from "../InfoWindowBody/InfoWindowBody";
import {PropsWithChildren} from "react";

export type EntityInfoWindowProps<T extends LocatableEntity> = InfoWindowProps & {
  entity: T
}

export const EntityInfoWindow = <T extends LocatableEntity, >(props: PropsWithChildren<EntityInfoWindowProps<T>>) => {
  const {
    entity,
    position,
    options,
    children,
    ...rest
  } = props;

  let latLngPos: google.maps.LatLng | google.maps.LatLngLiteral | undefined = position
  if (!latLngPos && entity.latLng) {
    latLngPos = new google.maps.LatLng(entity.latLng.latCoord, entity.latLng.longCoord)
  }

  return (
    <InfoWindow
      {...rest}
      position={latLngPos}
      options={{
        ...options,
        pixelOffset: options?.pixelOffset ?? new google.maps.Size(0, -30)
      }}>
      <InfoWindowBody>
        <div>
          {children}
        </div>
      </InfoWindowBody>
    </InfoWindow>
  );
};
